import * as React from "react";
import StoreContainer from "../stores/StoreContainer";

interface CallButtonProps {
  onClick: () => void;
}

class CallButton extends React.Component<CallButtonProps> {
  handleClick = () => {
    const override = StoreContainer.SettingStore.getCallButtonNumber();
    if (override) {
      window.open(`tel:${override}`);
      return;
    }

    StoreContainer.SettingStore.setClickToCall(true);
    this.props.onClick();
  };

  render() {
    const src = StoreContainer.SettingStore.getCallButtonUrl();

    if (!src) {
      return null;
    }

    return (
      <img
        onClick={() => this.handleClick()}
        onKeyDown={(e) => {
          return e.keyCode !== 13 || this.handleClick();
        }}
        src={src}
        alt="Open Live Call"
        tabIndex={0}
        style={{ cursor: "pointer" }}
        role="button"
      />
    );
  }
}

export default CallButton;
